import facts from "@/data/businessFacts.json";

/** Compare against the business timezone, never the visitor's timezone. */
export function isBusinessOpen(at: Date = new Date()): boolean {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: "Asia/Jerusalem", weekday: "short", hour: "2-digit", minute: "2-digit", hourCycle: "h23",
  }).formatToParts(at);
  const value = (type: string) => parts.find(part => part.type === type)?.value;
  const day = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].indexOf(value("weekday") ?? "");
  const hour = Number(value("hour")) + Number(value("minute")) / 60;
  return facts.hours.some(slot => slot.days.includes(day) && hour >= slot.opens && hour < slot.closes);
}

const dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
export const openingHoursSpecification = facts.hours.map(slot => ({
  "@type": "OpeningHoursSpecification",
  dayOfWeek: slot.days.map(day => dayNames[day]),
  opens: `${String(slot.opens).padStart(2, "0")}:00`,
  closes: `${String(slot.closes).padStart(2, "0")}:00`,
}));